import Image from '../../atoms/Image';
import searchIcon from '../../assets/images/search_grey.svg';
import {
  CustomSelect as Dropdown,
  ICustomSelectProps,
} from '../../molecules/Dropdown';
import { IMobileSearchButton, MobileTableActiveElement } from './SearchTable';

interface IAdvancedSearchProps {
  search: string;
  filterEnabled: boolean;
  sortEnabled: boolean;
  active: MobileTableActiveElement;
  tabSelectorProps?: ICustomSelectProps;
  handleSearch(value: string): void;
  handleOptions(value: MobileTableActiveElement): void;
  renderSearchButton?(data: IMobileSearchButton): void;
  onBack(): void;
}

const AdvancedSearch = ({
  search,
  filterEnabled,
  sortEnabled,
  active,
  tabSelectorProps,
  handleSearch,
  handleOptions,
  renderSearchButton,
  onBack,
}: IAdvancedSearchProps) => {
  return (
    <div className='search_table__content__advanced_search'>
      <div className='search_table__content__advanced_search__search'>
        {renderSearchButton && renderSearchButton({ search, onBack })}
        <div className='search_table__content__advanced_search__search__icon'>
          <Image size='m' src={searchIcon} />
        </div>
        <div className='search_table__content__advanced_search__search__placeholder'>
          <input
            type='search'
            className='search_table__content__advanced_search__search__placeholder__text'
            value={search}
            onChange={(e: any) => handleSearch(e.target.value)}
            placeholder='Search...'
            autoComplete='off'
          />
        </div>
      </div>
      {tabSelectorProps && <Dropdown {...tabSelectorProps} />}
      {filterEnabled && (
        <div
          className={`search_table__content__advanced_search__filter_icon icon-filter ${
            active === MobileTableActiveElement.filter
              ? 'search_table__content__advanced_search__filter_icon--active'
              : 'search_table__content__advanced_search__filter_icon--normal'
          }`}
          onClick={() => handleOptions(MobileTableActiveElement.filter)}
        />
      )}
      {sortEnabled && (
        <div
          className={`search_table__content__advanced_search__filter_icon icon-filter-alt ${
            active === MobileTableActiveElement.sort
              ? 'search_table__content__advanced_search__filter_icon--active'
              : 'search_table__content__advanced_search__filter_icon--normal'
          }`}
          onClick={() => handleOptions(MobileTableActiveElement.sort)}
        />
      )}
    </div>
  );
};

export default AdvancedSearch;
